import { AdvanceFilter } from './../../models/advance-filter';
import { FilterType } from './../../../shared/enums/filter-types';
import { LocationTypeLookup } from './../../../shared/constants/location-types';
import { AppStore } from 'src/app/shared/store/lookup-store.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UiStateStore } from '../../../shared/store/ui-state-store.service';

@Component({
  selector: 'app-advance-job-filter',
  templateUrl: './advance-job-filter.component.html',
  styleUrls: ['./advance-job-filter.component.scss']
})
export class AdvanceJobFilterComponent implements OnInit, OnDestroy {

  hideAdvanceFilters: boolean = true;
  optionsText: string = "More Options";
  locationTypeLookup = LocationTypeLookup;
  filterTypes = FilterType;
  advanceFilter: AdvanceFilter;
  subscription: Subscription;

  constructor(public lookUpStore: AppStore,
    private _uiStateStore: UiStateStore) {
    this.advanceFilter = new AdvanceFilter();
  }

  ngOnInit() {
  }

  toggleAdvanceFilters = () => {
    this.hideAdvanceFilters = !this.hideAdvanceFilters;
    this.optionsText = this.hideAdvanceFilters ? "More Options" : "Fewer Options";
  }

  setSelectedType = (value: any, filterType: FilterType) => {
    if(filterType == FilterType.SalaryType){
      this.advanceFilter.salaryType = value;
    } else if(filterType == FilterType.JobType){
      this.advanceFilter.jobType = value;
    } else if(filterType == FilterType.WorkType){
      this.advanceFilter.workType = value;
    }

    this._uiStateStore.setAdvanceJobFilterSelection(this.advanceFilter);
  }

  ngOnDestroy(): void {
  }
}
